import React from 'react';
import PropertyCard from '../components/PropertyCard.tsx';

const Properties: React.FC = () => {

  const properties = [
    {
      id: 1,
      title: "Chola Greens",
      price: "$750,000",
      location: "Thanjavur , TN",
      area: "1800 sq ft",
      image: "./chola-greens.jpeg",
      dtcpStatus: 'Approved' as 'Approved',
      reraStatus: 'Registered' as 'Registered',
      detailsAvailable: true // Enable button for Chola Greens
    },
    {
      id: 2,
      title: "Chola Flames",
      price: "$750,000",
      location: "Thanjavur , TN",
      area: "2,500 sq ft",
      image: "./chola-flames.png",
      detailsAvailable: false // Disable button for Chola Flames
    },
    {
      id: 3,
      title: "Chola Rail Gardens",
      price: "$1,200,000",
      location: "Thanjavur , TN",
      area: "1,800 sq ft",
      image: "./chola-rail-gardens.png",
      detailsAvailable: false // Disable button for Chola Rail Gardens
    },
    {
      id: 4,
      title: "Chola Meadows",
      price: "$450,000",
      location: "Thanjavur , TN",
      area: "1,900 sq ft",
      image: "./chola-meadows.png",
      detailsAvailable: false // Disable button for Chola Meadows
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pt-[160px]">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#041230] to-[#032744] text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-4">
            Our Properties
          </h1>
          <p className="text-xl text-center max-w-2xl mx-auto">
            Discover your perfect home from our extensive collection of premium properties
          </p>
        </div>
      </div>

      {/* Properties Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {properties.map((property) => (
            <PropertyCard key={property.id} property={property} />
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default Properties;